import { getData } from './script_data.js';
import { del } from './secure_fetch.js';
const imsEvents = require('./ims_events.js');
import { EVENT_NAME as LIBRARY_CREATED_EVENT_NAME } from '@adobe-fonts/site/events/LibraryCreatedEvent.js';
import { EVENT_NAME as LIBRARY_FOLLOW_EVENT_NAME } from '@adobe-fonts/site/events/LibraryFollowEvent.js';
import { EVENT_NAME as SAVE_TO_LIBRARY_LOAD_EVENT } from '@adobe-fonts/site/events/SaveToLibraryMenuLoadedEvent.js';
import { CollaborationSDK } from '@ccx-public/collaboration-sdk';


export default class LibrariesListener {
  constructor() {
    this.collaborationSDK = null;
  }

  deleteCache(libraryId) {
    return del(`/libraries/cache?library_urns=${libraryId}`);
  }

  getAdobeIMS() {
    return window.adobeIMS;
  }

  getAdobeId() {
    return window.adobeid;
  }

  listen() {
    window.addEventListener(LIBRARY_CREATED_EVENT_NAME, (event) => this.deleteCache(event.detail.library.library_urn));
    window.addEventListener(LIBRARY_FOLLOW_EVENT_NAME, (event) => this.deleteCache(event.detail.libraryUrn));

    imsEvents.addOnReadyHandler(async () => {
      window.addEventListener(SAVE_TO_LIBRARY_LOAD_EVENT, async (event) => {
        await this.monitorLibraryUrns(event.detail.libraries.map((library) => library.library_urn));
      });
      const cachedLibraryUrns = getData('cached-library-urns');
      if (!cachedLibraryUrns || cachedLibraryUrns.length === 0) {
        // This also handles logged out users
        return;
      }
      await this.monitorLibraryUrns(cachedLibraryUrns);
    });
  }

  async monitorLibraryUrns(libraryUrns) {
    const sdk = await this._getCollaborationSDK();
    const assetLinkManager = await sdk.getAssetLinkManager();
    const list = assetLinkManager.lists[0] || assetLinkManager.createList();
    for (const libraryUrn of libraryUrns) {
      if (list.monitoredAssetIDs.includes(libraryUrn)) {
        continue;
      }
      list.addAssetID(libraryUrn);
    }
    if (this.notifiedHandler) {
      list.off('notified', this.notifiedHandler);
    }
    this.notifiedHandler = this._handleNotified.bind(this);
    list.on('notified', this.notifiedHandler);
  }

  async _getCollaborationSDK() {
    if (this.collaborationSDK) {
      return Promise.resolve(this.collaborationSDK);
    }
    const adobeIMS = this.getAdobeIMS();
    const adobeId = this.getAdobeId();

    const config = {
      apiKey: 'TypeKit2',
      clientId: 'TypeKit2',
      appName: 'Adobe Fonts',
      environment: adobeId.environment === 'stg1' ? 'stage' : 'prod',
      cdnEnvironment: adobeId.environment === 'stg1' ? 'stage' : 'prod',
      locale: 'en-US',
      getAccessToken: () => {
        const token = adobeIMS.getAccessToken()?.token;

        if (!token) {
          throw new Error('No access token found');
        }

        return Promise.resolve(token);
      },
      getProfile: () => adobeIMS.getProfile()
    };

    this.collaborationSDK = CollaborationSDK.getCollaborationSDK('fonts-stable', config);
    return this.collaborationSDK;
  }

  _handleNotified(urns) {
    this.deleteCache(urns.join(','));
  }
}
